import { gql } from '@apollo/client';

export const SET_BONUS = gql`
  mutation SetBonus($input: SetBonusInput!) {
    setBonus(input: $input) {
      uuid
      bonus
    }
  }
`;

export const GET_BONUS_HISTORY = gql`
  query GetBonusHistory($uuid: String!, $page: Int, $first: Int) {
    getBonusHistory(uuid: $uuid, page: $page, first: $first) {
      data {
        type
        worker_first_name
        worker_last_name
        created_at
        add
        new_value
        old_value
        delta
      }
      paginatorInfo {
        currentPage
        lastPage
      }
    }
  }
`;

export const GET_DETAILED_SUMMARY_REPORT = gql`
  query BonusDetailedSummaryReport($input: ReportInput!) {
    bonusDetailedSummaryReport(input: $input) {
      data {
        values
      }
      labels
      summary {
        extraString
        extraValue
        title
        value
      }
    }
  }
`;
export const GET_DETAILED_SUMMARY_REPORT_FILE = gql`
  query BonusDetailedSummaryReport($input: ReportInput!) {
    bonusDetailedSummaryReport(input: $input) {
      url
    }
  }
`;

export const GET_BONUS_TIME_SERIES_REPORT = gql`
  query BonusDetailedTimeSeriesReport($input: BonusDetailedTimeSeriesInput!) {
    bonusDetailedTimeSeriesReport(input: $input) {
      data {
        values
      }
      keys
    }
  }
`;

export const GET_USER_BONUS_REPORT = gql`
  query UsersBonusReport($input: UsersBonusReport!) {
    usersBonusReport(input: $input) {
      labels
      extraLabels
      extraLabels2
      extraLabels3
      keys
      data {
        values
      }
    }
  }
`;
export const GET_USER_BONUS_REPORT_FILE = gql`
  query UsersBonusReport($input: UsersBonusReport!) {
    usersBonusReport(input: $input) {
      url
    }
  }
`;
